import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';

export default class MemberInvite extends Route {
  theme = 'group';

  @service router;

  model(params, transition) {
    let { to: toRouteInfo } = transition;

    const groupId = toRouteInfo.parent.params.group_id;
    const onClose = () => {
      this.router.transitionTo('app.group.members', groupId);
    };

    this.dispatch('group-member', 'invite', { id: groupId }, onClose);

    return this.modelFor('app.group');
  }
}
